import * as React from "react"
import 'intersection-observer';
import { Action, IOWidget, mk_widget } from "widgets-for-react"
import Plyr from 'react-plyr';
import { CMSState } from "../../../../cms/blocks/types.gen";
import { CookieSensitiveContentWrapper } from "../../../../cms/blocks/cookiebar.mod";
import { PublicSite_CustomPageData } from "../../../application.mod";
import { WordPress } from "../../../../wordpress/wordpress_api";
import { getImageAttribute } from "../../../utils/extra_images.mod";
import { t } from "i18next";

export type MediaBlockProps<extra_images> = {
  caption?: string
  useCookieBar: boolean
} & (
  {
    type: 'image'
    image: WordPress.MediaResponse
  } |
  {
    type: 'video'
    video: {
      id: string
      url: string
      type: 'video' | 'audio' | 'youtube' | 'vimeo'
      frameBorder: string
      allowFullScreen: boolean
    }
  }
)

export type MediaBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  header_classname: string,
  title_classname: string,
  intro_classname: string,
  content_classname: string
  figure_contentwidth_classname: string
  figure_fullwidth_classname: string
  figure_image_classname: string
  figure_video_classname: string
  media_classname: string
  image_classname: string
  placeholder_classname: string
  video_classname: string
  figcaption_classname: string
  caption_classname: string
  source_classname: string
  cookies_classname: string
  cookies_inner_classname: string
  cookies_text_classname: string
  cookies_clickable_classname: string
}>

declare var Optanon;

export function MediaBlock<CustomBlockData, extra_images>(
  props: MediaBlockProps<extra_images>,
  options?: { style?: MediaBlockStyle; key?: string }
): IOWidget<CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>, Action<CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (cmsState: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: setState => {
        return (
          <section className="block block--media">
            <div className="block__inner container--xl grid--spacing">
              <div className="block__content">
                <figure className="block__media">
                  {props.type === 'image' && props.image && (
                    <div className="block__visual">
                      <img className="block__image lazyload" width={getImageAttribute(props.image, 'media_block_s', 'width')} height={getImageAttribute(props.image, 'media_block_s', 'height')} alt={props.image.alt_text ? props.image.alt_text : ''}
                        src="/frontend/images/empty.png"
                        data-src={getImageAttribute(props.image, 'media_block_s', 'source_url')}
                        data-srcset={`${getImageAttribute(props.image, 'media_block_s', 'source_url')} 460w, ${getImageAttribute(props.image, 'media_block_m', 'source_url')} 920w, ${getImageAttribute(props.image, 'media_block_l', 'source_url')} 1840w`}
                        data-sizes="auto"
                      />
                    </div>
                  )}
                  {props.type == 'video' && props.video && (
                    <div className="block__visual">
                      {props.useCookieBar ? (
                          <CookieSensitiveContentWrapper
                            groupId={4}
                            options={{
                              style:
                                options && options.style
                                  ? {
                                      cookies_classname: options.style.cookies_classname,
                                      cookies_inner_classname: options.style.cookies_inner_classname,
                                      cookies_text_classname: options.style.cookies_text_classname,
                                      cookies_clickable_classname: options.style.cookies_clickable_classname
                                    }
                                  : undefined
                            }}
                            placeholder={
                              <div className="media__placeholder">
                                <div className="media__inner">
                                  <p>{t('cookiebar.video_placeholder')}</p>
                                  <p>{t("cookiebar.please")} <a className="optanon-toggle-display" onClick={() => Optanon.ToggleInfoDisplay()}>{t('cookiebar.adjust')}</a></p>
                                </div>
                              </div>
                            }
                          >
                            <Plyr
                              onPlay={() => window.dataLayer.push({
                                event: "event.fccorporate", category: "Video", action: "Start", label: window.location.pathname
                              })}
                              onPause={() => window.dataLayer.push({
                                event: "event.fccorporate", category: "Video", action: "Pause", label: window.location.pathname
                              })}
                              type={props.video.type}
                              videoId={props.video.url}
                            />
                          </CookieSensitiveContentWrapper>
                        ) : (
                          <Plyr
                            onPlay={() => window.dataLayer.push({
                              event: "event.fccorporate", category: "Video", action: "Start", label: window.location.pathname
                            })}
                            onPause={() => window.dataLayer.push({
                              event: "event.fccorporate", category: "Video", action: "Pause", label: window.location.pathname
                            })}
                            type={props.video.type}
                            videoId={props.video.url}
                          />  
                        )}
                    </div>
                  )}
                  {props.caption && 
                    <figcaption className="block__caption typo--4xs"><span>{props.caption}</span></figcaption>
                  }
                </figure>
              </div>
            </div>
          </section>
        );
      }
    })
  }
